module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie InputField consists of a default html <code>&lt;input&gt;</code> or <code>&lt;textarea&gt;</code>.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;InputField label placeholder = &quot;Max Mustermann&quot;/&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/InputField/README.md
// module id = 359
// module chunks = 0